import React, { useRef } from 'react';
import useScreenOrientation from './helpers/useScreenOrientation';

// import logoLandscape from "../assets/svgs/Logo_Cliente+Proyecto.svg";
// import logoPortrait from "../assets/svgs/Logo_Interfaz_Portrait.svg";
import logoColor from "../assets/svgs/Logo_Acesco_Color.svg";

export default function VideoPlayer({handleTransitionToProductList}: any) {

  const isLandscape = useScreenOrientation();
  const [videoTransition, setVideoTransition] = React.useState(true);
  
  const videoRef = useRef<HTMLVideoElement>(null);
  const clickRef = useRef<number>(0);

  const handleVideoEnd = () => {
    console.log('El video ha terminado de reproducirse.');
    setVideoTransition(false)
    handleTransitionToProductList()
  };

  React.useEffect(() => {
    if(videoRef.current){
      videoRef.current.play();
      //videoRef.current.pause();
    }
  }, []);

  const Clicked = () => {
    clickRef.current = clickRef.current + 1
    if(clickRef.current > 2){
      setVideoTransition(false)
      handleTransitionToProductList()
      clickRef.current = 0
    }
  };

  return (
    <div className={`video-player-container ${videoTransition ? 'transition-fade-in' : 'hidden transition-fade-out'}`} onClick={() => Clicked()}>
        <video ref={videoRef} className={`video-player ${true ? '' : 'hidden'}`} controls={false} muted playsInline onEnded={handleVideoEnd}>
          ${isLandscape ? 
            <source src={require('../assets/videos/intro_landscape.mp4')} type="video/mp4"/>
          :
            <source src={require('../assets/videos/intro_portrait.mp4')} type="video/mp4"/>
          }
          Your browser does not support the video tag.
        </video>
        <div className={`video-player-menu ${isLandscape ? '' : 'portrait'}`}>

          <div className={`video-player-top-menu ${isLandscape ? '' : 'portrait'}`}>
            <img className={`video-player-logo`} src={logoColor} alt=''/>

            <div className="video-player-skip" onClick={() => handleVideoEnd()} >
              <div className="video-player-skip-text">
                Saltar video
              </div>
            </div>
          </div>

        </div>
    </div>
  );
}
